<template>
  <div :style="{
      backgroundImage:
        $store.state.user.level == 'İlkokul'
          ? 'url(/static/images/5591276.jpg) !important'
          : '',
      height: 'calc(100vh - 53px)',
      paddingTop: '50px',
      backgroundSize: 'cover',
    }">
    <el-drawer :destroy-on-close="true" :append-to-body="true" title="Ayarlar" :visible.sync="settings"
      :with-header="false">
      <div class="row" style="padding: 50px">
        <div class="col-md-12">
          <label for="">{{ $t("module.speed") }}</label>
          <el-slider v-model="speed" :step="1" :min="1" :max="speeds.length" show-stops></el-slider>
        </div>
        <div class="col-md-12">
          <label for="">{{ $t("module.level") }}</label>
          <el-slider v-model="level" :step="1" :min="1" :max="7" show-stops></el-slider>
        </div>
        <div class="col-md-12 mb-3">
          <label class="dark-inverted d-block" for="">{{
            $t("module.autolevel")
            }}</label>
          <el-switch style="margin-top: 8px" v-model="autoLevel" :active-text="$t('module.yes')" :active-value="1"
            :inactive-value="0" :inactive-text="$t('module.no')">
          </el-switch>
        </div>
      </div>
    </el-drawer>
    <div id="goz_esnetme">
      <paused v-if="pause" @click="
          $root.$emit('pause', !pause);
          pause = false;
        "></paused>
      <a href="javascript:;" @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        " class="pause">
        <i :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"></i>
      </a>
      <a href="javascript:;" v-if="config == null || config == undefined" @click.stop="settings = true" class="settings">
        <i class="el-icon-setting"></i>
      </a>
      <div class="dark-inverted" style="
          font-size: 24px;
          border-radius: 5px;
          cursor: pointer;
          display: inline-block;
          text-align: center;
          padding: 0px 10px;
        " :style="{
          marginRight: 5 + 'px',
          backgroundColor: currentCounter != 0 ? '' : '#e5e5e5',
          color: currentCounter != 0 ? '' : '#e5e5e5',
        }">
        {{
        currentCounter != 0
        ? currentLetter
        : currentLetter
        .split("")
        .map((k) => "1")
        .join("")
        }}
      </div>
      <div style="
          display: flex;
          flex-direction: column;
          flex: 1;
          position: absolute;
          width: 90%;
          border-radius: 10px;
          align-items: center;
          justify-content: center;
          bottom: 60px;
        " v-if="currentCounter == 0">
        <el-input :class="
            currentStatus == true
              ? 'status-true'
              : currentStatus == false
              ? 'status-false'
              : 'inpt'
          " @keyup.enter.native="check" style="font-size: 22px" v-model="answer"
          :placeholder="$t('module.tak.placeholder')" ref="inpt"></el-input>
        <div style="
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: row;
            margin-top: 20px;
          ">
          <el-button style="margin-left: 10px" type="warning" round @click="pass">{{ $t("goremedim") }}</el-button>
          <el-button style="margin-left: 10px" type="primary" round @click="check">{{ $t("cevapla") }}</el-button>
        </div>
      </div>
    </div>
    <div :style="{ width: wrapper.width + 'px' }" style="margin: 0 auto; border-radius: 0px; margin-top: 15px">
      <div style="
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: row;
        " v-if="pause == false">
        <div style="display: flex; flex-direction: row">
          <span class="num" style="display: flex; align-items: center; justify-content: center">
            <div style="
                position: relative;
                z-index: 9999;
                background-color: red;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                color: white;
                align-items: center;
                justify-content: center;
                display: flex;
                font-size: 22px;
              ">
              <i class="fas fa-times"></i>
            </div>
            <span style="
                font-size: 35px;
                font-weight: bold;
                color: white;
                background: red;
                height: 40px;
                padding-left: 20px;
                margin-left: -20px;
                z-index: 1;
                position: relative;
                line-height: 45px;
                padding-right: 10px;
              ">{{ totalFalse }}</span>
          </span>
          <span class="num" style="display: flex; align-items: center; justify-content: center">
            <span style="
                font-size: 35px;
                font-weight: bold;
                color: white;
                background: rgb(28, 68, 156);
                height: 40px;
                padding-right: 20px;
                margin-right: -20px;
                z-index: 0;
                position: relative;
                line-height: 45px;
                padding-left: 10px;
              ">{{ totalTrue }}</span>
          </span>
          <svg height="40px" viewBox="0 0 512 512" width="40px" xmlns="http://www.w3.org/2000/svg"
            style="position: relative; z-index: 2">
            <path
              d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm0 0"
              fill="rgb(28, 68, 156)" />
            <path
              d="m385.75 201.75-138.667969 138.664062c-4.160156 4.160157-9.621093 6.253907-15.082031 6.253907s-10.921875-2.09375-15.082031-6.253907l-69.332031-69.332031c-8.34375-8.339843-8.34375-21.824219 0-30.164062 8.339843-8.34375 21.820312-8.34375 30.164062 0l54.25 54.25 123.585938-123.582031c8.339843-8.34375 21.820312-8.34375 30.164062 0 8.339844 8.339843 8.339844 21.820312 0 30.164062zm0 0"
              fill="#fafafa" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import level1 from "./level1";
import level2 from "./level2";
import level3 from "./level3";
import level4 from "./level4";
import level5 from "./level5";
import level6 from "./level6";
import level7 from "./level7";
import words_ru from "./words_ru";
import words_az from "./words_az";
export default {
  props: ["config"],
  name: "GozEsnekligi",
  data() {
    return {
      pause: false,
      speed: 1,
      speeds: [
        2000, 1900, 1800, 1700, 1600, 1500, 1400, 1300, 1200, 1100, 1000, 800,
        600, 500, 400, 300,
      ],
      words: [
        level1
          .replace(/ +(?= )/g, "")
          .split(",")
          .filter((k) => k.trim() != ""),
        level2
          .replace(/ +(?= )/g, "")
          .split(",")
          .filter((k) => k.trim() != ""),
        level3
          .replace(/ +(?= )/g, "")
          .split(",")
          .filter((k) => k.trim() != ""),
        level4
          .replace(/ +(?= )/g, "")
          .split(",")
          .filter((k) => k.trim() != ""),
        level5
          .replace(/ +(?= )/g, "")
          .split(",")
          .filter((k) => k.trim() != ""),
        level6
          .replace(/ +(?= )/g, "")
          .split(",")
          .filter((k) => k.trim() != ""),
        level7
          .replace(/ +(?= )/g, "")
          .split(",")
          .filter((k) => k.trim() != ""),
      ],
      top: 0,
      left: 0,
      word: null,
      rotate: 0,
      currentCounter: 5,
      startCounter: 5,
      level: 1,
      levels: [
        {
          metin: `Dar kapısından başka aydınlık girecek hiçbir yeri olmayan dükkanında tek başına, gece gündüz kıvılcımlar saçarak çalışan Koca Ali, tıpkı kafese konmuş terbiyeli bir arslanı andırıyordu. Uzun boylu, iri pençeli, kalın pazılı, geniş omuzlu bir pehlivandı. On yıldır bu karanlık in içinde ham demirden dövdüğü kılıç ve namluları tüm Anadolu’da, tüm Rumeli’de sınır boylarında büyük bir ün kazanmıştı. Hatta İstanbul’da bile yeniçeriler, satın alacakları kamaların, saldırmaların, yatağanların üstünde “Ali Usta’nın işi” damgasını arıyorlardı. O, çeliğe çifte su vermesini biliyordu. Uzun kılıçlar değil, yaptığı kısacık bıçaklar bile iki kat olur, kırılmazdı, “Çifte su vermek” sanatının, yalnız ona özgü bir sırrı vardı. Yanına çırak almaz, kimseyle çok konuşmaz, dükkanından dışarı çıkmaz, durmadan uğraşırdı. Bekardı. Hısımı, akrabası yoktu. Kentin yabancısıydı. Kılıçtan, demirden, çelikten, ateşten başka söz bilmez, pazarlığa girişmez, müşterileri ne verirse alırdı. Yalnız savaş zamanları ocağını söndürür, dükkanının kapısını kilitler, kaybolur, savaştan sonra ortaya çıkardı. Kentte onunla ilgili birçok hikaye söylenirdi. Kimi “cellat elinden kaçmış bir çelebi”, kimi “sevgilisi öldüğü için dünyadan elini eteğini vakitsiz çekmiş garip” derdi. Siyah şahane gözlerinin mağrur bakışından, soylu davranışlarından, gururlu suskunluğundan, düzgün sözlerinden onun öyle sıradan bir adam olmadığı belliydi… Ama kimdi? Nereliydi? Nereden gelmişti? Bunları bilen yoktu. Halk onu seviyordu. Kentte böyle tanınmış bir ustanın bulunması herkes için ayrı bir övünç kaynağıydı.`,
          find: "yeri",
        },
        {
          metin: `Koca Ali en kalın, en katı demirleri mısır yaprağı gibi incelten, kağıt gibi yumuşatan sanatını kimseden öğrenmemiş, kendi kendine bulmuştu. Daha on iki yaşındayken, sert bir beylerbeyi olan babasının başı vurulmuş, öksüz kalmıştı. Amcası çok zengindi. Gösterişe düşkün bir vezirdi. Onu yanına aldı. Okutmak istedi. Belki devlet katında yetiştirecek, büyük görevlere çıkaracaktı. Ama Ali’nin yaratılışında “başkasına gönül borcu olmak” gibi bir sızlanmaya yer yoktu. “Ben kimseye eyvallah etmeyeceğim,” dedi. Bir gece amcasının konağından kaçtı. Başıboş bir adsız gibi dağlar, tepeler, dereler aştı. Adını bilmediği ülkelerde dolaştı. Sonunda Erzurum’da yaşlı bir demircinin yanına girdi. Otuz yaşına kadar Anadolu’da uğramadığı kent kalmadı. Kimseye boyun eğmedi. Gönül borcu olmadı. Ekmeğini taştan çıkardı. Alnının teriyle kazandı, içinde “kutsal ateş”ten bir alev bulunan her yaratıcı gibi, para için değil, sanatı, sanatının zevki için çalışıyordu. “Çeliğe çifte su vermek” onun aşkıydı. Gönüllü olarak savaşlara gittiği zamanlar yeniçerilerin, sipahilerin, sekbanların arasında, Ali Usta, işinin övgüsünü duydukça tadı dille anlatılmaz bir mutluluk duyardı. Ölünceye kadar böyle hiç durmadan çalışırsa daha birkaç bin gaziye kırılmaz kılıçlar, kalkanlar parçalayan çelik yatağanlar, zırhlar, keskin ağır saldırmalar yapacaktı. Bunu düşündükçe gülümser, tatlı tatlı yüreği çarpar, ruhundan kopan bir atılımla örsünün üzerinde milyonlarca kıvılcım tutuştururdu.`,
          find: `gibi`,
        },
      ],
      options: [],
      currentLetter: "",
      lodash: _,
      wrapper: {
        width: 0,
        height: 0,
      },
      positions: [],
      totalTrue: 0,
      totalFalse: 0,
      counts: [],
      flash: false,
      answer: null,
      settings: false,
      autoLevel: false,
      levelLock: false,
      currentStatus: null,
      reactions: [],
      lastPickTime: new Date().getTime(),
    };
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };
    this.start();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    pick(index) {
      this.options[index].picked = true;
    },
    getColor(letter) {
      if (
        this.flash == true &&
        letter.letter == this.currentLetter &&
        letter.picked == false
      ) {
        return "#ddd";
      }
      if (
        this.flash == true &&
        letter.letter == this.currentLetter &&
        letter.picked == true
      ) {
        return "green";
      }
      if (
        this.flash == false &&
        letter.letter == this.currentLetter &&
        letter.picked == true
      ) {
        return "green";
      }
      if (
        this.flash == false &&
        letter.letter != this.currentLetter &&
        letter.picked == true
      ) {
        return "red";
      }
      if (
        this.flash == true &&
        letter.letter != this.currentLetter &&
        letter.picked == true
      ) {
        return "red";
      }
    },
    check() {
      if (this.flash) return;
      this.flash = true;
      console.log(
        this.answer.trim().toLocaleLowerCase(),
        this.currentLetter.trim().toLocaleLowerCase()
      );
      if (
        this.answer.trim().toLocaleLowerCase() ==
        this.currentLetter.trim().toLocaleLowerCase()
      ) {
        this.totalTrue += 1;
        this.currentStatus = true;
        this.reactions.push(new Date().getTime() - this.lastPickTime);
      } else {
        this.totalFalse += 1;
        this.answer = this.currentLetter;
        this.currentStatus = false;
      }

      clearInterval(this.interval);
      setTimeout(() => {
        this.currentStatus = null;
        this.answer = "";
        this.start();
        this.flash = false;
      }, 2000);
    },
    pass() {
      this.currentStatus = null;
      this.answer = "";
      this.start();
      this.flash = false;
    },
    start() {
      var before = this.currentLetter.trim();
      this.flash = false;
      this.positions = [];
      this.options = [];
      this.currentCounter = 1;

      while (true) {
        this.options.push(_.shuffle(this.words[this.level - 1])[0]);

        this.currentLetter = this.options.join(" ");
        if (this.currentLetter != before) {
          break;
        }
      }

      this.interval = setTimeout(() => {
        this.currentCounter = 0;
        this.lastPickTime = new Date().getTime();
      }, this.speeds[this.speed - 1]);
    },
  },
  computed: {
    currentSpeed() {
      return this.speeds[this.speed - 1];
    },
  },
  watch: {
    currentCounter: function () {
      if (this.currentCounter == 0) {
        setTimeout(() => {
          this.$refs.inpt.focus();
        }, 200);
      }
    },
    currentSpeed: function () {
      if (this.levelLock) return;
      clearInterval(this.interval);
      clearInterval(this.startInterval);
      this.start();
    },
    level: function () {
      if (this.levelLock) return;
      clearInterval(this.interval);
      clearInterval(this.startInterval);
      this.start();
    },
    totalTrue: function () {
      if (this.autoLevel == 0) return;
      this.levelLock = true;

      if (this.totalTrue % 2 == 0) {
        this.speed += 1;
      }
      if (this.totalTrue % 6 == 0) {
        this.level = Math.min(this.level + 1, 7);
      }

      setTimeout(() => {
        this.levelLock = false;
      }, 500);
    },
    totalFalse: function () {
      if (this.autoLevel == 0) return;
      this.levelLock = true;
      if (this.speed == 1) {
        this.speed = this.level == 1 ? 1 : this.speeds.length - 1;
        this.level = Math.max(this.level - 1, 1);
      } else {
        this.speed -= 1;
      }

      setTimeout(() => {
        this.levelLock = false;
      }, 500);
    },
  },
  created() {
    if (this.$i18n.locale == "ru") {
      this.words = [
        [
          ...words_ru
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length <= 4),
        ],
        [
          ...words_ru
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 5),
        ],
        [
          ...words_ru
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 6),
        ],
        [
          ...words_ru
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 7),
        ],
        [
          ...words_ru
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 8),
        ],
        [
          ...words_ru
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 9),
        ],
        [
          ...words_ru
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length > 10),
        ],
      ];
    }

    if (this.$i18n.locale == "az") {
      this.words = [
        [
          ...words_az
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length <= 4),
        ],
        [
          ...words_az
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 5),
        ],
        [
          ...words_az
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 5),
        ],
        [
          ...words_az
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 4),
        ],
        [
          ...words_az
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 5),
        ],
        [
          ...words_az
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 4),
        ],
        [
          ...words_az
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 5),
        ],
      ];
    }
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 700px;
  height: 500px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  background-color: white !important;
}
</style>

<style lang="less">
.status-true .el-input__inner {
  background-color: #1c449c !important;
  transition: 0.5s;
  color: white !important;
  transition: 0.5s;
  height: 60px;
  line-height: 60px;
  text-align: center;
  border-radius: 15px;
  box-shadow: -1px 2px 9px rgb(0 0 0 / 10%);
}

.status-false .el-input__inner {
  background-color: red !important;
  transition: 0.5s;
  color: white !important;
  transition: 0.5s;
  height: 60px;
  line-height: 60px;
  text-align: center;
  border-radius: 15px;
  box-shadow: -1px 2px 9px rgb(0 0 0 / 10%);
}

.inpt .el-input__inner {
  height: 60px;
  line-height: 60px;
  text-align: center;
  border-radius: 15px;
  box-shadow: -1px 2px 9px rgb(0 0 0 / 10%);
}
</style>


// WEBPACK FOOTER //
// src/components/modules/Takistoskop.vue